import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import "@wato/ui/fonts";
import "@wato/ui/styles.css";
import "@xyflow/react/dist/style.css";
import "./xyflow-theme.css";
import { App } from "./App";
import { RootErrorBoundary } from "./components/RootErrorBoundary";
import { installChunkReload } from "./lib/chunk-reload";
import { registerServiceWorker } from "./pwa/registerServiceWorker";
import { initTheme } from "./lib/theme";
import { setThemeColor } from "./pwa/setThemeColor";
import { captureInstallPrompt } from "./features/mobile-shell/useInstallPrompt";

installChunkReload();
captureInstallPrompt(); // before React mounts: `beforeinstallprompt` fires only once, early
initTheme();
registerServiceWorker();
setThemeColor();

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Missing #root element");

createRoot(rootElement).render(
  <StrictMode>
    <RootErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </RootErrorBoundary>
  </StrictMode>,
);
